<!--<h1 mat-dialog-title>Hi {{data.name}}</h1>-->
<form [formGroup]="dialogoGroup">
<h1 mat-dialog-title>Información a Modificar</h1>
<div mat-dialog-content>
  <!--<p>Información a Modificar</p>-->
  <mat-form-field appearance="outline" hintLabel="Max 2 caracteres">
    <mat-label>Orden</mat-label>
    <input  formControlName="txtTitulo" matInput #txtOrdenOpciones [(ngModel)]="data.titulo" maxlength="2">
    <mat-error>Este campo es <strong>necesario</strong>!</mat-error>
    <mat-hint align="end">{{txtOrdenOpciones.value?.length || 0}}/2</mat-hint>
  </mat-form-field>
  <mat-form-field appearance="outline" hintLabel="Max 140 caracteres">
    <mat-label>Descripción</mat-label>
    <input  formControlName="txtSubTitulo" matInput #txtDescripcionOpciones [(ngModel)]="data.subTitulo">
    <mat-error>Este campo es <strong>necesario</strong>!</mat-error>
    <mat-hint align="end">{{txtDescripcionOpciones.value?.length || 0}}/140</mat-hint>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Valor</mat-label>
    <input  formControlName="txtCodigo" matInput type="number" [(ngModel)]="data.codigo">
    <mat-error>Este campo es <strong>necesario</strong>!</mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Bloque</mat-label>
    <mat-select formControlName="cbxBloques">
      <mat-option (onSelectionChange)="changeCbxBloques($event)" *ngFor="let item of listaBloques"
        [value]="item.id">
        {{item.valor}}
      </mat-option>
    </mat-select>
    <mat-error>Este campo es <strong>necesario</strong>!</mat-error>
  </mat-form-field>
  <mat-form-field class="invisible">
    <mat-label>Valor</mat-label>
    <input formControlName="txtDescripcionBloque" matInput [(ngModel)]="data.descripcionBloque">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button  mat-raised-button (click)="onNoClick()">Cancelar</button>
  <button [disabled]="!dialogoGroup.valid"  mat-raised-button [mat-dialog-close]="data" cdkFocusInitial>Actualizar</button>
</div>
</form>
